import React from 'react';
import {
  ComponentAppearance,
  ComponentSize,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';
import Tag from 'src/modules/shared/components/atoms/tag';

interface BadgeProps {
  children: React.ReactNode;
  variant?: ComponentVariant;
  appearance?: ComponentAppearance;
  size?: ComponentSize;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  appearance = 'soft',
  size = 'md',
  className = '',
}) => {
  return (
    <Tag
      content={children}
      variant={variant}
      size={size}
      appearance={appearance}
      className={className}
    />
  );
};
